cv.PublicMembersRowEmptyView = Marionette.LayoutView.extend({
  className: 'member-empty',
  template: cv.Templates['public/members/members_row_empty'],

  events : {
  },

  templateHelpers: function(){
    return {
    };
  },

  initialize: function(options){
    console.log('PublicMembersRowEmptyView initialized');
  },

  onShow: function(){
  }
});
